import { render, staticRenderFns } from "./gantt-group.vue?vue&type=template&id=71763850&scoped=true&"
import script from "./gantt-group.vue?vue&type=script&lang=ts&"
export * from "./gantt-group.vue?vue&type=script&lang=ts&"
import style0 from "./gantt-group.vue?vue&type=style&index=0&id=71763850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71763850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71763850')) {
      api.createRecord('71763850', component.options)
    } else {
      api.reload('71763850', component.options)
    }
    module.hot.accept("./gantt-group.vue?vue&type=template&id=71763850&scoped=true&", function () {
      api.rerender('71763850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/gantt/components/gantt-group.vue"
export default component.exports